import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Message, Statement } from '../../../../core/models/chat.models';
import { MessageWithRefsComponent } from '../message-with-refs/message-with-refs.component';
import { TraceViewerComponent } from '../trace-viewer/trace-viewer.component';
import { ThemeToggleService } from '../../../../partials/theme-toggle/theme-toggle.service';

@Component({
  selector: 'app-chat-message-list',
  imports: [CommonModule, MessageWithRefsComponent, TraceViewerComponent],
  templateUrl: './chat-message-list.component.html'
})
export class ChatMessageListComponent implements OnChanges {
  themeService = inject(ThemeToggleService);
  @Input() messages: Message[] = [];
  @Output() inlineReferenceClick = new EventEmitter<Statement>();
  @Output() showAllResources = new EventEmitter<any[]>();

  @ViewChild('messagesEnd') messagesEnd!: ElementRef;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['messages']) {
      setTimeout(() => this.scrollToBottom(), 100);
    }
  }

  private scrollToBottom(): void {
    try {
      this.messagesEnd?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    } catch (e) {
      console.error('Error scrolling:', e);
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
